import { render, staticRenderFns } from "./AccessesTable.vue?vue&type=template&id=62f65f08&scoped=true"
import script from "./AccessesTable.vue?vue&type=script&lang=js"
export * from "./AccessesTable.vue?vue&type=script&lang=js"
import style0 from "./AccessesTable.vue?vue&type=style&index=0&id=62f65f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f65f08",
  null
  
)

export default component.exports